import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import InvoiceGenerator from './pages/admin/InvoiceGenerator';
import QuotationGenerator from './pages/admin/QuotationGenerator';
import './App.css';

// Protected Route Component for Admin
const ProtectedAdminRoute = ({ children }) => {
  const isAdminLoggedIn = localStorage.getItem('bricks_brain_admin_token');
  
  if (!isAdminLoggedIn) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

// Layout wrapper for pages with Navbar and Footer
const PageLayout = ({ children }) => (
  <>
    <Navbar />
    {children}
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes with Navbar and Footer */}
          <Route path="/" element={<PageLayout><Home /></PageLayout>} />
          <Route path="/about" element={<PageLayout><About /></PageLayout>} />
          <Route path="/services" element={<PageLayout><Services /></PageLayout>} />
          <Route path="/contact" element={<PageLayout><Contact /></PageLayout>} />

          {/* Admin Login (NO Navbar and Footer) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          
          {/* Protected Admin Routes WITH Navbar and Footer */}
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedAdminRoute>
                <PageLayout>
                  <AdminDashboard />
                </PageLayout>
              </ProtectedAdminRoute>
            } 
          />
          <Route 
            path="/admin/invoice" 
            element={
              <ProtectedAdminRoute>
                <PageLayout>
                  <InvoiceGenerator />
                </PageLayout>
              </ProtectedAdminRoute>
            } 
          />
          <Route 
            path="/admin/quotation" 
            element={
              <ProtectedAdminRoute>
                <PageLayout>
                  <QuotationGenerator />
                </PageLayout>
              </ProtectedAdminRoute>
            } 
          />
          
          {/* Redirect /admin to /admin/login */}
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          
          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
